import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { FeedService } from '../../services/feed.service';
import { Like, Message, Comment } from '../../models/feed-model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'src/app/models/user';

@Component({
  selector: 'makaw-feed-detail',
  templateUrl: './feed-detail.component.html',
  styleUrls: ['./feed-detail.component.scss'],
})
export class FeedDetailComponent implements OnInit, OnDestroy {
  @Input() postId: any;
  @Input() user: User;
  @Output() sendComment = new EventEmitter<any>();
  @Output() sendLikeEvent = new EventEmitter<any>();
  @Output() sendUnlikeEvent = new EventEmitter<any>();

  private destroyed$ = new Subject();

  public comments: Comment[];
  public likes: Like[];
  public commentsLoaded = false;
  public likesLoaded = false;
  public textMessage = '';
  public liked = true;

  constructor(private readonly feedService: FeedService) {}

  ngOnInit() {
    this.feedService
      .getComments(this.postId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((comments: Comment[]) => {
        this.comments = comments.sort(
          (commentA: Comment, commentB: Comment) =>
            commentA.date - commentB.date
        );

        this.commentsLoaded = true;
        console.log(this.comments);
      });

    this.feedService
      .getLikes(this.postId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((likes: Like[]) => {
        this.likes = likes;
        this.liked = !!this.likes.find(
          (like: Like) => like.uid === this.user.uid
        );
        this.likesLoaded = true;
        console.log(this.likes);
      });
  }

  public isDataLoaded() {
    return this.commentsLoaded && this.likesLoaded;
  }

  public sendMessage() {
    if (this.textMessage.length > 0 && this.textMessage.length < 400) {
      const message: Message = {
        content: this.textMessage,
        postId: this.postId,
        author: this.user.firstName,
        owner: this.user.uid,
        date: new Date().getTime(),
      };
      this.sendComment.emit(message);
      this.textMessage = '';
    }
  }

  public manageLike() {
    const likeOutput = {
      uid: this.user.uid,
      post: this.postId,
    };

    if (this.liked) this.sendUnlikeEvent.emit(likeOutput);
    else this.sendLikeEvent.emit(likeOutput);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
